<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn" @click="initHomeworkManageStuData()"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">作业管理&gt;</div>
      </div>
      <div class="body_content">
        <table class="table table-striped tabShow">
          <thead>
          <tr>
            <th width="10%">作业类别</th>
            <th width="15%">作业名称</th>
            <th width="15%">作业要求</th>
            <th width="15%">附件</th>
            <th width="15%">我上传的</th>
            <th width="10%">截止日期</th>
            <th width="10%">上传日期</th>
            <th width="10%">操作</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(home, index) in homeWorkList" :key="index">
            <td width="10%">{{home.type}}</td>
            <td width="15%">{{home.name}}</td>
            <td width="15%" class="tabTd_content_ellipsis" :title="home.summary">{{home.summary}}</td>
            <td width="15%" class="tabTd_content_ellipsis" :title="home.fileName">
              <a @click="openPreviewModal(home.fileName, home.filePath)">
                {{home.fileName}}
              </a>
            </td>
            <td width="15%" class="tabTd_content_ellipsis" :title="home.sfileName">
              <a @click="openPreviewModal(home.sfileName, home.sfilePath)">
                {{home.sfileName}}
              </a>
            </td>
            <td width="10%">{{home.deadline}}</td>
            <td width="10%">{{home.suploadTime}}</td>
            <td width="10%">
              <div class="uploadBtn" data-toggle="modal" data-target="#myModal" data-placement="bottom" title="上传作业"
                   :class="{displayNone: checkDate(home.deadline)}"
                   @click="homeWorkId=home.id;putHomeworkIdIntoUpload()">
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <!--图片显示-->
        <div class="modal fade" id="myModal_showAllImages" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showAllImages" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog modal-dialog-look">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_showAllImages">
                  图片预览
                </h4>
              </div>
              <div class="modal-body modal-body-look">
                <img :src="imageSrc" class="previewImg"/>
              </div>
            </div>
          </div>
        </div>

        <!--视频显示-->
        <div class="modal fade" id="myModal_showVideo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showVideo" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog modal-dialog-look">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" id="video_btn" class="close" data-dismiss="modal" aria-hidden="true" @click="enableMute()">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_showVideo">
                  视频预览
                </h4>
              </div>
              <div class="modal-body modal-body-look">
                <video id="video_sp" class="showVideo video-js" :src="videoSrc" :type="videoType" controls="controls" controlslist="nodownload" autoplay="autoplay" loop="loop" :poster="videoThumbSrc">
                </video>
              </div>
            </div>
          </div>
        </div>

        <!--文档显示-->
        <div class="modal fade" id="myModal_showFile" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showFile" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog modal-dialog-look">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_showFile">
                  文档预览
                </h4>
              </div>
              <div class="modal-body modal-body-look">
                <iframe :src="fileSrc" width="100%" height="700px"></iframe>
              </div>
            </div>
          </div>
        </div>

        <!-- 模态框（Modal） -->
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel">
                  上传作业
                </h4>
              </div>
              <div class="modal-body">
                <!--上传-->
                <uploader :options="upload.options" :file-status-text="upload.statusText" class="uploader-example" ref="uploader">
                  <uploader-unsupport></uploader-unsupport>
                  <uploader-drop>
                    <p>拖拽作业文件至此处</p>
                    <uploader-btn :attrs="upload.attrs.file">选择文件</uploader-btn>
                  </uploader-drop>
                  <uploader-list></uploader-list>
                </uploader>
              </div>
              <!--<div class="modal-footer">
                <button type="button" class="btn btn-default btn_save" @click="saveUpload()">
                  保存
                </button>
                <button type="button" class="btn btn-default btn_cancel" data-dismiss="modal">
                  取消
                </button>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";

  import {getContentSize} from './mainView';

  export default {
    name: "homeworkManageStu",
    data() {
      return {
        homeWorkId: '',
        //作业
        homeWorkList: [],

        //图片
        imageSrc: '',

        //视频
        videoSrc: '',
        videoThumbSrc: '',
        videoType: 'video/mp4',

        //文档
        fileSrc: '',

        //上传
        upload: {
          uploader: null,
          options: {
            target: this.$store.state.serviceBase + 'studentSchoolwork/sswUpload.action',
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
              //studentId: this.$store.state.studentId
            },
            simultaneousUploads: 1,//同时上传数
            testChunks: false,
            chunkSize: 10*1024*1024*1024,//分片大小：10G
            singleFile: true,
          },
          attrs: {
            file: {
              accept: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/pdf'
            },
            /*image: {
              accept: 'image/!*'
            },
            video: {
              accept: 'video/!*'
            },*/
          },
          statusText: {
            success: '成功了',
            error: '出错了',
            uploading: '上传中',
            paused: '暂停中',
            waiting: '等待中',
          },
        },
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        //绑定加载关闭模态框时的事件
        this_.closeModal();

        //获得上传组件对象
        this_.upload.uploader = this_.$refs.uploader.uploader;
        //上传组件绑定事件
        this_.loadUpload();

        this_.initHomeworkManageStuData();
      });
    },
    methods: {
      /*enableMute(){

        videoSrc='';

      },*/
      /**
       * 初始加载数据
       */
      initHomeworkManageStuData(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'schoolwork/findHomeWorkListByStudent',
          params: {}
        }).then(function (homeResp) {
          //作业
          let homeworkData = homeResp.data;
          if(homeworkData.success){
            this_.homeWorkList = homeworkData.list;
          }
        })
      },

      checkDate(date){
        let this_ = this;
        let date_now = new Date();
        date_now = date_now.getFullYear()+"-"+(date_now.getMonth() + 1)+"-"+date_now.getDate();
        date_now = new Date(date_now);
        let date_my = new Date(date);
        if(date_now <= date_my){
          //显示
          return false;
        }
        //不显示
        return true;
      },

      /**
       * 添加参数
       */
      putHomeworkIdIntoUpload(){
        let this_ = this;
        this_.upload.options.query.schoolworkId = this_.homeWorkId;
        this_.upload.options.query.studentId = this_.$store.state.studentId;
      },

      /**
       * 打开文件模态框
       */
      openFileModal(filePath) {
        let this_ = this;
        let data = filePath.substring(0, 11);
        let fileId = filePath.substring(11, filePath.indexOf('.'));
        this_.fileSrc = this_.$store.state.serviceBase + "resources/" + data + fileId + "_file/" + fileId + ".html";
        $("#myModal_showFile").modal("show");
      },
      /**
       * 打开预览模态框
       */
      openPreviewModal(fileName, filePath) {
        let this_ = this;

        let suffix = fileName.substring(fileName.indexOf('.')+1);

        if("mp4".indexOf(suffix)!=-1){
          this_.videoSrc = this_.$store.state.serviceBase + "resources/" + filePath;
          $("#myModal_showVideo").modal("show");
        }else if("doc,docx,pdf".indexOf(suffix)!=-1) {
          let data = filePath.substring(0, 11);
          let fileId = filePath.substring(11, filePath.indexOf('.'));
          this_.fileSrc = this_.$store.state.serviceBase + "resources/" + data + fileId + "_file/" + fileId + ".html";
          $("#myModal_showFile").modal("show");
        }else {
          this_.imageSrc = this_.$store.state.serviceBase + "resources/" + filePath;
          $("#myModal_showAllImages").modal("show");
        }
      },
      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#myModal").on('hide.bs.modal', function () {
          this_.upload.uploader.cancel();
        });
        $("#myModal_showVideo").on('hide.bs.modal', function () {
          this_.videoSrc='';
        });

      },
      /**
       * 上传加载
       */
      loadUpload(){
        let this_ = this;
        this_.upload.uploader.on('fileAdded', function (file, event) {
          if(this_.upload.attrs.file.accept.indexOf(file.fileType)==-1){
            (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
            return false;
          }
        })
        this_.upload.uploader.on('fileSuccess', function (rootFile, file, message, chunk) {
          if(message){
            let message_ = JSON.parse(message);
            if(message_.success){
              message_.message.showMessage();
              this_.initHomeworkManageStuData();
              $("#myModal").modal("hide");
              this_.upload.uploader.cancel();
            }else {
              message_.message.showMessage();
            }
          }
        })
        this_.upload.uploader.on('fileComplete', function (rootFile) {
          //console.info(rootFile);
        })
        this_.upload.uploader.on('fileError', function (rootFile, file, message) {
          (file.name+"上传失败").showMessage();
        })
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .tabShow {
    margin: 2% 0 0 0;
    width: 100%;
    max-height: 98%;
    table-layout: fixed;
  }
  .tabShow tr {
    /*border-bottom: 1px grey solid;*/
    height: 50px;
  }
  .tabShow tr td{
    border: 0px;
    line-height: 32px;
  }


  .modal-body-look {
    text-align: center;
  }
  .modal-body-look img {
    width: 100%;
  }
  .modal-dialog-look {
    width: 60%;
  }
  .tabShow tr th {
    background-color: #cccccc;
    color: black;
    font-size: 16px;
    text-align: center;
    line-height: 30px;
  }
  .tabShow tr td {
    text-align: center;
    font-size: 16px;
  }
  .uploadBtn {
    margin: auto;
    width: 22px;
    height: 22px;
    background-image: url("../assets/img/right/student/uploadBtn.png");
    background-size: 100% 100%;
  }
  .uploadBtn:hover {
    background-image: url("../assets/img/right/student/uploadBtn_over.png");
  }

  .tabTd_content_ellipsis {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    -moz-text-overflow: ellipsis;
  }
  /*表头固定*/
  .tabShow thead tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .tabShow tbody{
    display: block;
    /*overflow-y: scroll;*/
    overflow: auto;
  }
  .tabShow tbody tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .tabShow{
    /*border: none;*/
  }
  .tabShow tbody::-webkit-scrollbar{
    width:0;
  }

  .displayNone {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/homeworkManageStu.vue